import _ from 'lodash';
import donorHelpers from './donorHelpers';
// import storiesHelpers from './storiesHelpers';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');
module.exports = {
  combinePathFile: function (obj) {
    if (!obj) {
      return null;
    }
    return obj.path + obj.file_name
  },
  safeJson: function (str) {
    var safe = null;
    try {
      safe = JSON.parse(str);
    } catch (e) {
      safe = null;
    }
    return safe;
  },

  searchStoriesPills: function (dm, stories, searchStr) {
    let storiesFound = [];

    stories.forEach((story) => {
      let match = 0;

      if (Number(dm.contents.story_category) === Number(story.folder)) {
        if (story.contents.headline.toLowerCase().indexOf(searchStr) !== -1) {
          match++;
        }

        if (story.contents.story.toLowerCase().indexOf(searchStr) !== -1) {
          match++;
        }

        if (match > 0) {
          storiesFound.push(story);
        }
      }
    });

    return storiesFound;
  },

  searchDonorList: function (content, searchStr) {
    let donorLists = _.filter(content.dm_active, { display_module_type: "Donor List" });

    if (donorLists.length > 0) {
      let groupedDonorLists = [];
      donorLists.forEach((dm) => {
        let donorListGrouped = donorHelpers.donorsIncluded(content.donors.donorCategories, dm.content.include_categories);
        groupedDonorLists.push({
          module: dm,
          group: donorListGrouped
        });
      })
    }
  },

  searchStories: function (content, searchStr) {
    let timelineModuleType = _.find(content.display_module_types, { name: "Timeline" });

    let storiesModules = [];
    let timelineModules = [];

    content.dm_active.forEach((dm) => {
      if (dm.display_module_type === "Stories") {
        storiesModules.push(dm);
      }

      if (dm.display_module_type === timelineModuleType.id) {
        timelineModules.push(dm);
      }
    });

    let results = {}
    storiesModules.forEach((dm) => {
      switch (content.project.theme.name) {
        case "Miami":
          if (results[dm.contents.custom_fields.stories_type.val] === undefined) {
            results[dm.contents.custom_fields.stories_type.val] = [];
          }
          results[dm.contents.custom_fields.stories_type.val].push({
            display_module: dm,
            stories: this.searchStoriesPills(dm, content.stories, searchStr)
          });
          break;
        default:
          results['simple'] = this.searchStoriesPills(dm, content.stories, searchStr);
          break;
      }
    });

    return results;
  },

  searchStory: function(content, searchStr, folderExceptions = []) {
    // Get folders which type is excempted to be searched
    let exceptionFolders = content.story_categories
    .filter(fl => {
      let type = _.get(fl, 'contents.custom_fields.folder_type.val.value', null);
      return (type && (folderExceptions.indexOf(type) > -1));
    })
    .map(fl => {
      return fl.id
    });
    // Get stories ids that are in any of those folders and
    // exclude them in the search.
    let excemptedStories = content.folder_modules
    .filter(fm => {
      return exceptionFolders.indexOf(fm.folder) > -1 && fm.model === 'story';
    })
    .map(fm => {
      return fm.module_id
    })
    .filter((v, i, a) => a.indexOf(v) === i);
    
    let foundStories = [];
    for (let i = 0; i < content.stories.length; i++) {
      let story = content.stories[i];
      if (excemptedStories.indexOf(story.id) > -1) {
        continue;
      }
      // Remove Stories with a Story Type of "Attract Loop"
      const storyType = _.get(story, 'contents.custom_fields.story_type.val.value', null);
      if (storyType === 'checkerboard') {
        continue;
      }
      let match = 0;
      if (story.name.toLowerCase().indexOf(searchStr) !== -1) {
        match++;
      }
  
      if (_.get(story, 'contents.headline', null) && story.contents.headline.toLowerCase().indexOf(searchStr) !== -1) {
        match++;
      }
  
      let textOps = _.get(story.contents, 'custom_fields.body.val.ops', {});
      let converter = new QuillDeltaToHtmlConverter(textOps, {});
      let richText = converter.convert();
      if (richText.toLowerCase().indexOf(searchStr) !== -1) {
        match++;
      }
  
      if (match > 0) {
        foundStories.push(story);
      }
    }

    return foundStories;
  }
}




// WEBPACK FOOTER //
// ./src/utils/dataHelpers.js